import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Helmet } from "react-helmet-async"; // Global Helmet
import Navbar from "./Components/Navbar.jsx";
import Footer from "./Components/Footer.jsx";
import useScrollTopOnLoad from "./hooks/useScrollTopOnLoad";

import BuildProHomeContent from "./Components/BuildProHomeContent.jsx";

// Pages
import Onexvideo from "./Pages/Onexvideo.jsx";
import Buyerschoice from "./Pages/Buyerschoice";
import SimilarProduct from "./Pages/SimilarProducts.jsx";
import DashboardContent from "./Pages/DashboardContent";
import Checkout from "./Pages/Checkout";
import Cart from "./Pages/Cart";
import Wishlist from "./Components/Wishlist";
import ProductList from "./Pages/ProductList.jsx";
import ProductDetails from "./Pages/productDetails.jsx";
import BlogPage from "./Components/BlogPage.jsx";
import BlogDetail from "./Components/BlogDetail.jsx";
import FAQ from "./Components/FAQ.jsx";
import Mission from "./Components/Mission.jsx";
import Vision from "./Components/Vision.jsx";
import TermsAndConditions from "./Components/Terms&condition.jsx";
import JoinWithUs from "./Components/JoinWithUs.jsx";
import OrderPage from "./Components/OrderPage.jsx";
import BulkRequest from "./Components/BulkRequest.jsx";
import AllProducts from "./Components/AllProducts.jsx";

// Auth Components
import LoginForm from "./Components/authcomponents/LoginForm.jsx";
import Verifyotp from "./Components/authcomponents/Verifyotp.jsx";
import ForgotPasswordForm from "./Components/authcomponents/ForgotPasswordForm.jsx";

// Utility & Security
import ProductComparison from "./Components/ProductComparison.jsx";
import PrivateRoute from "./config/PrivateRoute.jsx";

// Notifications
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Order Tracking
import OrderTracking from "./Pages/OrderTracking.jsx";

import AboutCompany from "./Components/productListcomponents/companyContent.jsx"

function App() {
  useScrollTopOnLoad(); // 👈 page smoothly goes to top on reload
  return (
    <Router>

      <Helmet>
        <title>BuildPro OGCS - Construction Materials Online</title>

        <meta
          name="description"
          content="Buy construction materials, tools, and equipment online with BuildPro OGCS. Trusted by engineers, contractors, and builders across India."
        />

        <meta name="robots" content="index,follow" />
        <meta charSet="utf-8" />
      </Helmet>


      <ToastContainer />
      <div>
        <Navbar />
        <Routes>
          {/* Home Route with Hero + Section */}
          <Route
            path="/"
            element={
              <>
                <Onexvideo />
                <AllProducts />
                <Buyerschoice />
              </>
            }
          />

          {/* Public Routes */}
          <Route path="/dashboard" element={<DashboardContent />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="/verify-otp" element={<Verifyotp />} />
          <Route path="/forgot-password" element={<ForgotPasswordForm />} />
          <Route path="/Buyerschoice" element={<Buyerschoice />} />
          <Route path="/mission" element={<Mission />} />
          <Route path="/vision" element={<Vision />} />
          <Route path="/blogPage" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/about" element={<AboutCompany />} />
          <Route path="/join-with-us" element={<JoinWithUs />} />
          <Route path="/similar-products" element={<SimilarProduct />} />
          <Route path="/products/:subcategoryId" element={<ProductList />} />
          <Route
            path="/product/details/:productId"
            element={<ProductDetails />}
          />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/bulk-request" element={<BulkRequest />} />

          {/* Private Routes */}
          <Route
            path="/wishlist"
            element={
              <PrivateRoute>
                <Wishlist />
              </PrivateRoute>
            }
          />
          <Route
            path="/checkout"
            element={
              <PrivateRoute>
                <Checkout />
              </PrivateRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <PrivateRoute>
                <OrderTracking />
              </PrivateRoute>
            }
          />
          <Route
            path="/cart"
            element={
              <PrivateRoute>
                <Cart />
              </PrivateRoute>
            }
          />

        </Routes>

        <Footer />
      </div>

    </Router>
  );
}

export default App;
